import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=2500e52d&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FullLayout.vue"
export default component.exports